import { io } from "socket.io-client";
import { jwtDecode } from "jwt-decode"; // Usar la importación con nombre

let socket = null;

export const initializeSocket = async (companyToken) => {
  try {
    const decodedToken = jwtDecode(companyToken);
    let URL_BACK_SOCKET = null;

    const urls = (process.env.URL_BACKEND_API || "").split(",");
    // Mapea appId a la URL correspondiente
    const appId =
      decodedToken.appId || decodedToken.appID || decodedToken.appId;
    let urlBackend = urls[0]; // Valor por defecto

    if (appId === "APP123") {
      urlBackend = urls[0];
    } else if (appId === "HICHATHELPDESK-PROD") {
      urlBackend = urls[2];
    } else if (appId === "HICHAT-PROD") {
      urlBackend = urls[1];
    }

    if ("urlSocket" in decodedToken) {
      // TOKEN ANTIGUO
      URL_BACK_SOCKET = decodedToken.urlSocket;
    } else if ("companyUuId" in decodedToken) {
      // TOKEN NUEVO: necesita fetch
      const companyId = decodedToken.companyUuId;

      const response = await fetch(
        `${urlBackend}/chat-bubble-config/${companyId}`,
        {
          method: "GET", // ← explícalo si no es POST
          headers: {
            Authorization: `Bearer ${companyToken}`,
            "Content-Type": "application/json",
            "User-Agent": "MyApp/1.0", // ← header que evita ERR_NGROK_6024
          },
        }
      );

      if (!response.ok) {
        throw new Error("No se pudo obtener la configuración del chat.");
      }

      const result = await response.json();
      URL_BACK_SOCKET = result?.data?.socket_url;

      if (!URL_BACK_SOCKET) {
        throw new Error("URL del socket no encontrada en la respuesta.");
      }
    } else {
      throw new Error(
        "Token no válido: no se reconoce ni 'urlSocket' ni 'companyId'."
      );
    }

    const urlParts = new URL(URL_BACK_SOCKET);

    const baseUrl = `${urlParts.protocol}//${
      urlParts.host
    }${urlParts.pathname.replace(/\/socket\.\w+$/, "")}`;

    const pathMatch = urlParts.pathname.match(/\/(socket\.\w+)$/);
    const socketPath = pathMatch ? `/${pathMatch[1]}` : null;

    if (!socketPath) {
      throw new Error("Path del socket no encontrado o inválido.");
    }

    socket = io(baseUrl, {
      path: socketPath,
      transports: ["websocket"],
      autoConnect: true,
      reconnectionAttempts: 3,
      reconnectionDelay: 2000,
    });

    socket.on("connect", () => {
      console.log("✅ Conectado al servidor con éxito.");
    });

    socket.on("disconnect", (reason) => {
      console.log("🔌 Desconectado del servidor:", reason);
    });

    socket.on("reconnect_attempt", (attemptNumber) => {
      console.log(`🔁 Intento de reconexión automática #${attemptNumber}`);
    });

    socket.on("reconnect", () => {
      console.log("🔗 Reconexión automática exitosa al servidor.");
    });

    window.socket = socket;
    console.log(socket);
  } catch (error) {
    console.error("❌ Error al inicializar el socket:", error);
  }
};
/**
 * Obtiene un conversationId desde localStorage si no han pasado 30 min.
 * Si no existe o ya caducó, genera uno nuevo.
 */
export const getOrCreateConversationId = () => {
  // Leer el ID y el timestamp
  const existingConversationId = localStorage.getItem("conversationId");
  const existingTimestamp = localStorage.getItem("conversationTimestamp");

  // Si hay ID y timestamp, verificamos cuánto tiempo pasó
  if (existingConversationId && existingTimestamp) {
    const createdAt = parseInt(existingTimestamp, 10);
    const now = Date.now();
    const THIRTY_MINUTES = 60 * 60 * 1000; // 3600000 ms

    // Si han pasado menos de 60 min, reusamos el ID
    if (now - createdAt < THIRTY_MINUTES) {
      return existingConversationId;
    }
  }

  // Si no hay ID/timestamp o ya caducó, creamos uno nuevo
  const newConversationId = crypto.randomUUID();
  localStorage.setItem("conversationId", newConversationId);
  localStorage.setItem("conversationTimestamp", Date.now().toString());

  return newConversationId;
};

/**
 * Borra el conversationId anterior, genera uno nuevo y avisa al socket.
 * Retorna el nuevo conversationId.
 */
export const resetConversationId = (companyToken) => {
  // 1. Borrar el ID anterior
  localStorage.removeItem("conversationId");
  localStorage.removeItem("conversationTimestamp");
  console.log("Conversación reiniciada");

  // Generar uno nuevo
  const newConversationId = crypto.randomUUID();
  localStorage.setItem("conversationId", newConversationId);
  localStorage.setItem("conversationTimestamp", Date.now().toString());

  // Avisar al socket si está conectado
  if (window.socket && window.socket.connected) {
    window.socket.emit("reconnect", {
      companyToken,
      conversationId: newConversationId,
    });
  }

  return newConversationId;
};
